import React from 'react';
import { FaTimes, FaShoppingCart, FaEye, FaMars, FaVenus, FaExchangeAlt } from 'react-icons/fa';

const QuickViewModal = ({ item, onClose, onOrderClick, onViewDetails }) => {
  if (!item) return null;

  const getItemPrice = () => {
    if (item.type === 'guppy') {
      if (item.couplecount > 0 && item.coupleprice) return item.coupleprice;
      if (item.malecount > 0 && item.maleprice) return item.maleprice;
      if (item.femalecount > 0 && item.femaleprice) return item.femaleprice;
      return 0;
    }
    if (item.type === 'food') {
      // Use selectedFoodType if available, otherwise default to flakes
      const foodType = item.selectedFoodType || 'flakes';
      if (foodType === 'powder') {
        return item.powderPrice || 0;
      }
      return item.flakesPrice || 0;
    }
    return item.price || 0;
  };

  const getItemImage = () => {
    if (item.type === 'guppy') {
      return item.maleimage || item.femaleimage || '';
    }
    return item.image || '';
  };

  const getItemStatus = () => {
    if (item.sold_status) return { text: 'نفذت الكمية', color: '#ef4444' };
    if (item.type === 'guppy') {
      const available = (item.couplecount || 0) + (item.malecount || 0) + (item.femalecount || 0);
      if (available > 0) return { text: 'متاح', color: '#10b981' };
    } else if (item.type === 'food') {
      const foodType = item.selectedFoodType || 'flakes';
      const available = foodType === 'powder' 
        ? (item.powderQuantity || 0)
        : (item.flakesQuantity || 0);
      if (available > 0) return { text: 'متاح', color: '#f97316' };
    } else {
      if ((item.quantity || 0) > 0) return { text: 'متاح', color: '#10b981' };
    }
    return { text: 'غير متوفر', color: '#ef4444' };
  };

  const status = getItemStatus();
  const price = getItemPrice();
  const image = getItemImage();

  return (
    <>
      <div className="quick-view-overlay" onClick={onClose}>
        <div className="quick-view-modal" onClick={(e) => e.stopPropagation()}>
          <button className="quick-view-close" onClick={onClose} aria-label="إغلاق">
            <FaTimes size={20} />
          </button>

          <div className="quick-view-content">
            {/* Image Section */}
            <div className="quick-view-image-section">
              {image ? (
                <img src={image} alt={item.name} className="quick-view-image" />
              ) : (
                <div className="quick-view-placeholder">
                  {item.type === 'guppy' ? '🐠' : item.type === 'plant' ? '🌱' : item.type === 'food' ? '🍽️' : '🏺'}
                </div>
              )}
              {status && (
                <div className="quick-view-status-badge" style={{ background: `${status.color}20`, borderColor: status.color, color: status.color }}>
                  {status.text}
                </div>
              )}
            </div>

            {/* Info Section */}
            <div className="quick-view-info-section">
              <h2 className="quick-view-title">{item.name || 'عنصر غير مسمى'}</h2>
              
              <div className="quick-view-price-section">
                <span className="quick-view-price-label">السعر:</span>
                <span className="quick-view-price-value">{price.toFixed(2)} DA</span>
              </div>

              {/* Guppy Specific Info */}
              {item.type === 'guppy' && (
                <div className="quick-view-details">
                  {item.couplecount > 0 && (
                    <div className="quick-view-detail-row">
                      <span>أزواج متوفرة:</span>
                      <span>{item.couplecount}</span>
                    </div>
                  )}
                  {item.malecount > 0 && (
                    <div className="quick-view-detail-row">
                      <span>ذكور متوفرة:</span>
                      <span>{item.malecount}</span>
                    </div>
                  )}
                  {item.femalecount > 0 && (
                    <div className="quick-view-detail-row">
                      <span>إناث متوفرة:</span>
                      <span>{item.femalecount}</span>
                    </div>
                  )}
                </div>
              )}

              {/* Plant Specific Info */}
              {item.type === 'plant' && (
                <div className="quick-view-details">
                  {item.quantity !== undefined && (
                    <div className="quick-view-detail-row">
                      <span>الكمية المتاحة:</span>
                      <span>{item.quantity} قطعة</span>
                    </div>
                  )}
                  {item.care && (
                    <div className="quick-view-detail-row">
                      <span>العناية:</span>
                      <span>{item.care}</span>
                    </div>
                  )}
                </div>
              )}

              {/* Aquarium Specific Info */}
              {item.type === 'aquarium' && (
                <div className="quick-view-details">
                  {item.size && (
                    <div className="quick-view-detail-row">
                      <span>الحجم:</span>
                      <span>{item.size}</span>
                    </div>
                  )}
                  {item.material && (
                    <div className="quick-view-detail-row">
                      <span>المادة:</span>
                      <span>{item.material}</span>
                    </div>
                  )}
                  {item.quantity !== undefined && (
                    <div className="quick-view-detail-row">
                      <span>الكمية:</span>
                      <span>{item.quantity}</span>
                    </div>
                  )}
                </div>
              )}

              {/* Food Specific Info */}
              {item.type === 'food' && (
                <div className="quick-view-details">
                  {(() => {
                    const foodType = item.selectedFoodType || 'flakes';
                    const hasFlakes = (item.flakesQuantity || 0) > 0 && (item.flakesPrice || 0) > 0;
                    const hasPowder = (item.powderQuantity || 0) > 0 && (item.powderPrice || 0) > 0;
                    return (
                      <>
                        <div className="quick-view-detail-row">
                          <span>النوع المحدد:</span>
                          <span>{foodType === 'powder' ? 'مسحوق' : 'رقائق'}</span>
                        </div>
                        {hasFlakes && (
                          <div className="quick-view-detail-row">
                            <span>رقائق - السعر:</span>
                            <span>{item.flakesPrice?.toFixed(2) || 0} DA</span>
                          </div>
                        )}
                        {hasFlakes && (
                          <div className="quick-view-detail-row">
                            <span>رقائق - الكمية:</span>
                            <span>{item.flakesQuantity || 0} قطعة</span>
                          </div>
                        )}
                        {hasPowder && (
                          <div className="quick-view-detail-row">
                            <span>مسحوق - السعر:</span>
                            <span>{item.powderPrice?.toFixed(2) || 0} DA</span>
                          </div>
                        )}
                        {hasPowder && (
                          <div className="quick-view-detail-row">
                            <span>مسحوق - الكمية:</span>
                            <span>{item.powderQuantity || 0} قطعة</span>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              )}

              {/* Action Buttons */}
              <div className="quick-view-actions">
                {!item.sold_status && (
                  <button
                    className="quick-view-order-btn"
                    onClick={() => {
                      onOrderClick();
                      onClose();
                    }}
                  >
                    <FaShoppingCart size={16} />
                    اطلب الآن
                  </button>
                )}
                {onViewDetails && (
                  <button
                    className="quick-view-details-btn"
                    onClick={() => {
                      onViewDetails();
                      onClose();
                    }}
                  >
                    <FaEye size={16} />
                    عرض التفاصيل الكاملة
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .quick-view-overlay {
          position: fixed;
          inset: 0;
          z-index: 2000;
          background: rgba(0, 0, 0, 0.85);
          backdrop-filter: blur(8px);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px;
          animation: fadeIn 0.2s ease-out;
        }

        .quick-view-modal {
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.98), rgba(30, 41, 59, 0.98));
          backdrop-filter: blur(20px);
          border: 1px solid rgba(16, 185, 129, 0.3);
          border-radius: 24px;
          width: 100%;
          max-width: 600px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          position: relative;
          animation: slideUp 0.3s ease-out;
          direction: rtl;
        }

        .quick-view-close {
          position: absolute;
          top: 16px;
          left: 16px;
          background: rgba(239, 68, 68, 0.2);
          color: #f87171;
          border: 1px solid rgba(239, 68, 68, 0.3);
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          z-index: 10;
        }

        .quick-view-close:hover {
          background: rgba(239, 68, 68, 0.3);
          transform: scale(1.1);
        }

        .quick-view-content {
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .quick-view-image-section {
          position: relative;
          width: 100%;
          height: 300px;
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(30, 41, 59, 0.9));
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .quick-view-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .quick-view-placeholder {
          font-size: 80px;
          opacity: 0.5;
        }

        .quick-view-status-badge {
          position: absolute;
          top: 16px;
          right: 16px;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid;
        }

        .quick-view-info-section {
          padding: 24px;
        }

        .quick-view-title {
          color: white;
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 20px 0;
          text-align: right;
        }

        .quick-view-price-section {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.2);
          border-radius: 12px;
          margin-bottom: 20px;
        }

        .quick-view-price-label {
          color: #94a3b8;
          font-size: 16px;
          font-weight: 600;
        }

        .quick-view-price-value {
          color: #fbbf24;
          font-size: 24px;
          font-weight: 700;
        }

        .quick-view-details {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 24px;
        }

        .quick-view-detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px;
          background: rgba(51, 65, 85, 0.3);
          border-radius: 8px;
          color: white;
          font-size: 14px;
        }

        .quick-view-detail-row span:first-child {
          color: #94a3b8;
          font-weight: 600;
        }

        .quick-view-detail-row span:last-child {
          color: white;
          font-weight: 500;
        }

        .quick-view-actions {
          display: flex;
          gap: 12px;
          flex-direction: column;
        }

        .quick-view-order-btn,
        .quick-view-details-btn {
          padding: 14px 20px;
          border-radius: 12px;
          border: none;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.2s ease;
        }

        .quick-view-order-btn {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
        }

        .quick-view-order-btn:hover {
          background: linear-gradient(135deg, #059669, #047857);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
        }

        .quick-view-details-btn {
          background: rgba(6, 182, 212, 0.15);
          color: #06b6d4;
          border: 1px solid rgba(6, 182, 212, 0.3);
        }

        .quick-view-details-btn:hover {
          background: rgba(6, 182, 212, 0.25);
          transform: translateY(-2px);
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @media (max-width: 640px) {
          .quick-view-modal {
            max-width: 100%;
            border-radius: 16px;
            max-height: 95vh;
          }

          .quick-view-image-section {
            height: 250px;
          }

          .quick-view-info-section {
            padding: 20px;
          }

          .quick-view-title {
            font-size: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default QuickViewModal;

